const autocompleteModalFilterEquip = {
  groups: 'Grupo',
  place: 'Lugar',
  area: 'Departamentos',
  company: 'Tercera empresa',
  equipmentModel: 'Tipo del Equipo',
  site: 'Sitios',
  status: 'Status'
};

export default autocompleteModalFilterEquip;
